import { render } from "./Tags.vue?vue&type=template&id=5498e2a2&scoped=true&lang=pug"
import script from "./Tags.js?vue&type=script&lang=js&external"
export * from "./Tags.js?vue&type=script&lang=js&external"

import "./Tags.vue?vue&type=style&index=0&id=5498e2a2&lang=scss&scoped=true"
import "./Tags.vue?vue&type=style&index=1&id=5498e2a2&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5498e2a2"]])

export default __exports__